import {PromocodesInterface} from "@/views/Admin/Events/Event/Promocodes/Promocodes.interface";

export const PromocodesSchema: PromocodesInterface = {
    isLoading: false,
    tabs: ['promocodes', 'groups'],
    promocodes: {
        data: [],
        isLoading: false,
        meta: {
            currentPage: 1,
            from: 0,
            lastPage: 0,
            perPage: 10,
            to: 0,
            total: 0,
            sizes: {10: '10', 20: '20', 50: '50', 100: '100'}
        },
    },
    groups: {
        data: [],
        isLoading: false,
        meta: {
            currentPage: 1,
            from: 0,
            lastPage: 0,
            perPage: 10,
            to: 0,
            total: 0,
            sizes: {10: '10', 20: '20', 50: '50', 100: '100'}
        },
    },
    events: {
        data: [],
        isLoading: false,
        meta: {
            currentPage: 1,
            from: 0,
            lastPage: 0,
            perPage: 10,
            to: 0,
            total: 0,
            sizes: {10: '10', 20: '20', 50: '50', 100: '100'}
        },
    },
};
